module.exports = __webpack_public_path__ + "img/error.8fa04bb.jpg";